import React, { FC } from 'react';
import { CaretDown } from '@phosphor-icons/react';
import { LOAD_UNIT, LOAD_UNIT_LABELS, getLoadUnitsForInputMode } from '../../../enums/programming';
import { EmomRoundDetail } from './workoutBuilderTypes';
import styles from './WorkoutBuilderModal.module.scss';

interface EmomRoundTableProps {
  rounds: EmomRoundDetail[];
  /** Input mode dell'esercizio: filtra le unità ammesse (BUG E). */
  inputMode?: string;
  onChange: (updated: EmomRoundDetail[]) => void;
}

const PREFERRED_UNITS = [LOAD_UNIT.KG, LOAD_UNIT.LB, LOAD_UNIT.PERCENT_1RM, LOAD_UNIT.PERCENT_BW];

const EmomRoundTable: FC<EmomRoundTableProps> = ({ rounds, inputMode, onChange }) => {
  const allowedUnits = getLoadUnitsForInputMode(inputMode);
  const POPULAR_UNITS = PREFERRED_UNITS.filter((u) => allowedUnits.includes(u));
  const OTHER_UNITS = allowedUnits.filter((u) => !PREFERRED_UNITS.includes(u));
  const update = (idx: number, patch: Partial<EmomRoundDetail>) => {
    const next = rounds.map((r, i) => (i === idx ? { ...r, ...patch } : r));
    onChange(next);
  };

  return (
    <div className={styles.emomRoundTable}>
      {/* Header */}
      <div className={styles.emomRoundTableHeader}>
        <span className={styles.emomRoundTableCell} style={{ width: 44 }}>Round</span>
        <span className={styles.emomRoundTableCell} style={{ flex: 1 }}>Reps</span>
        <span className={styles.emomRoundTableCell} style={{ flex: 1 }}>Carico</span>
        <span className={styles.emomRoundTableCell} style={{ width: 80 }}>Unità</span>
        <span className={styles.emomRoundTableCell} style={{ flex: 1 }}>Tempo</span>
        <span className={styles.emomRoundTableCell} style={{ flex: 2 }}>Note</span>
      </div>

      {rounds.map((rd, idx) => (
        <div key={rd.round} className={styles.emomRoundTableRow}>
          <span className={styles.emomRoundTableRoundNum} style={{ width: 44 }}>
            {rd.round}
          </span>
          <input
            type="text"
            className={styles.smallInput}
            placeholder="8"
            value={rd.reps}
            onChange={(e) => update(idx, { reps: e.target.value })}
            style={{ flex: 1 }}
          />
          <input
            type="text"
            className={styles.smallInput}
            placeholder="—"
            value={rd.loadValue}
            onChange={(e) => update(idx, { loadValue: e.target.value })}
            style={{ flex: 1 }}
          />
          <div className={styles.selectWrapper} style={{ width: 80, flexShrink: 0 }}>
            <select
              className={styles.unitSelect}
              value={rd.loadUnit}
              onChange={(e) => update(idx, { loadUnit: e.target.value as LOAD_UNIT })}
            >
              <optgroup label="Più usate">
                {POPULAR_UNITS.map((u) => (
                  <option key={u} value={u}>{LOAD_UNIT_LABELS[u]}</option>
                ))}
              </optgroup>
              <optgroup label="Altre">
                {OTHER_UNITS.map((u) => (
                  <option key={u} value={u}>{LOAD_UNIT_LABELS[u]}</option>
                ))}
              </optgroup>
            </select>
            <CaretDown size={11} className={styles.selectIcon} />
          </div>
          <input
            type="text"
            className={styles.smallInput}
            placeholder="3010"
            value={rd.tempo}
            title="Tempo di esecuzione (es. 3010 = 3s eccentrica · 0 pausa · 1s concentrica · 0 pausa alta)"
            onChange={(e) => update(idx, { tempo: e.target.value })}
            style={{ flex: 1 }}
          />
          <input
            type="text"
            className={styles.smallInput}
            placeholder="—"
            value={rd.notes}
            onChange={(e) => update(idx, { notes: e.target.value })}
            style={{ flex: 2 }}
          />
        </div>
      ))}
    </div>
  );
};

export default EmomRoundTable;
